import { Box, Typography } from '@mui/material'

function Archive() {
  return (
    <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
      <Typography>Archive Page</Typography>
    </Box>
  )
}

export default Archive
